export default __webpack_public_path__ + "a399805e35bddbd334b8c863d63af525.svg";